import { message } from 'antd'

const handleAppError = (error, ...rest) => {
  if(error?.response?.status === 403) return
  
  const data = error?.response?.data
  let msg = data?.message || data?.msg || data?.error
  msg = !!msg ? msg : error?.message
  message.error(msg || 'Something went wrong')
}

export default handleAppError
